var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaskFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7263 9.8073L12.0438 5.43543L13.339 2.32193H7.79883L9.09409 5.43543L9.41153 9.8073L9.51117 11.1859L9.51812 14.5793H11.6174L11.6244 11.1859L11.7263 9.8073Z",
    fill: "url(#paint0_linear_205_1983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7542 8.96532L14.7896 7.80643L15.9875 9.61763L14.1987 13.1036L16.5645 13.0735H20.0819L18.7542 8.96532Z",
    fill: "url(#paint1_linear_205_1983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35065 7.80643L2.38609 8.96532L1.06766 13.0735H4.58502L6.94383 13.1036L5.15503 9.61763L6.35065 7.80643Z",
    fill: "url(#paint2_linear_205_1983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1203 11.9979L11.6198 14.5817L11.9836 14.8315L14.1964 13.1035L14.2636 11.3687L12.1203 11.9979Z",
    fill: "url(#paint3_linear_205_1983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88132 11.3687L6.94156 13.1035L9.15439 14.8315L9.51818 14.5817L9.01768 11.9979L6.88132 11.3687Z",
    fill: "url(#paint4_linear_205_1983)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5952 5.98827L20.2324 2.89559L19.2778 0.0249634L11.9836 5.43543L14.7061 7.87581L18.7541 8.96762L19.6254 7.9452L19.2453 7.67225L19.8524 7.11941L19.389 6.75624L19.9961 6.29361L19.5952 5.98827Z",
    fill: "url(#paint5_linear_205_1983)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54501 5.98827L0.907806 2.89559L1.86245 0.0249634L9.15669 5.43543L6.43409 7.87581L2.38612 8.9653L1.51489 7.94289L1.89489 7.66994L1.28781 7.11709L1.75123 6.75393L1.14415 6.2913L1.54501 5.98827Z",
    fill: "url(#paint6_linear_205_1983)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15271 9.61761L6.88127 11.3687L6.94151 13.1035L5.15271 9.61761Z",
    fill: "url(#paint7_linear_205_1983)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9875 9.61761L14.1987 13.1035L14.2659 11.3687L15.9875 9.61761Z",
    fill: "url(#paint8_linear_205_1983)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5532 16.0806L11.9836 14.8315L12.1875 16.5062L12.1643 17.2117L14.5532 16.0806Z",
    fill: "#FF9F5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58707 16.0805L8.976 17.2094L8.95978 16.5039L9.15673 14.8291L6.58707 16.0805Z",
    fill: "#FF9F5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5621 13.0735L14.5532 16.0806L18.8514 17.2626L20.0795 13.0735H16.5621Z",
    fill: "url(#paint9_linear_205_1983)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06766 13.0735L2.28877 17.2626L6.58699 16.0806L4.58502 13.0735H1.06766Z",
    fill: "url(#paint10_linear_205_1983)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86243 0.0249634L9.15666 5.43543L8.01201 2.32193L1.86243 0.0249634Z",
    fill: "url(#paint11_linear_205_1983)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1282 2.32193L11.9836 5.43543L19.2778 0.0249634L13.1282 2.32193Z",
    fill: "url(#paint12_linear_205_1983)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35065 7.80644L5.15271 9.61764L9.41386 9.80732L9.15666 5.43546L6.35065 7.80644Z",
    fill: "url(#paint13_linear_205_1983)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7895 7.80644L11.9835 5.43546L11.7263 9.80732L15.9875 9.61764L14.7895 7.80644Z",
    fill: "url(#paint14_linear_205_1983)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58707 16.0806L9.15673 14.8315L6.9439 13.1035L6.58707 16.0806Z",
    fill: "#9383FA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9836 14.8315L14.5532 16.0806L14.1964 13.1035L11.9836 14.8315Z",
    fill: "#9383FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1987 13.1035L14.5556 16.0806L16.5645 13.0735L14.1987 13.1035Z",
    fill: "url(#paint15_linear_205_1983)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94157 13.1035L6.58473 16.0806L4.57581 13.0735L6.94157 13.1035Z",
    fill: "url(#paint16_linear_205_1983)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9875 9.61761L11.7263 9.80729L12.1202 11.9978L12.7505 10.6794L14.2659 11.3687L15.9875 9.61761Z",
    fill: "#9C5ADD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88127 11.3687L8.3897 10.6794L9.01995 11.9978L9.41386 9.80729L5.15271 9.61761L6.88127 11.3687Z",
    fill: "#9C5ADD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1203 11.9979L11.7264 9.80731L11.6267 11.186L11.6198 14.5817L12.1203 11.9979Z",
    fill: "url(#paint17_linear_205_1983)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02002 11.9979L9.52051 14.5817L9.51356 11.186L9.41393 9.80731L9.02002 11.9979Z",
    fill: "url(#paint18_linear_205_1983)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1805 17.2001L12.1898 16.5038L11.9998 16.3373H9.14048L8.95743 16.5038L8.97365 17.2094L6.58472 16.0805L7.41887 16.7629L9.11731 17.938H12.0206L13.7191 16.7629L14.5532 16.0805L12.1805 17.2001Z",
    fill: "#DF7554"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9835 14.8315L11.6197 14.5816H9.52046L9.15667 14.8315L8.95972 16.5062L9.14277 16.3396H11.9998L12.1898 16.5062L11.9835 14.8315Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.00668686,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7505 10.6794L12.1202 11.9978L14.2659 11.3687L12.7505 10.6794Z",
    fill: "#161616"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38975 10.6794L9.02 11.9978L6.88132 11.3687L8.38975 10.6794Z",
    fill: "#161616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_1983",
    x1: 10.5701,
    y1: 2.32082,
    x2: 10.5701,
    y2: 14.5805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCABFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_1983",
    x1: 17.1393,
    y1: 7.80661,
    x2: 17.1393,
    y2: 13.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B65FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADA2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_205_1983",
    x1: 4.00472,
    y1: 7.80661,
    x2: 4.00472,
    y2: 13.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B65FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADA2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_205_1983",
    x1: 11.6201,
    y1: 13.0992,
    x2: 14.266,
    y2: 13.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAAAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_205_1983",
    x1: 6.88185,
    y1: 13.0992,
    x2: 9.52015,
    y2: 13.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAAAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_205_1983",
    x1: 13.3344,
    y1: 7.76991,
    x2: 21.1442,
    y2: 3.25322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#541758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#4F206C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4D2577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B45B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_205_1983",
    x1: 6.4016,
    y1: 7.72852,
    x2: -0.325901,
    y2: 2.07384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#541758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#4F206C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4D2577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B45B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_205_1983",
    x1: 5.15329,
    y1: 11.3603,
    x2: 6.94246,
    y2: 11.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA86F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5281,
    stopColor: "#B786F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#AE86F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA86F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_205_1983",
    x1: 14.1978,
    y1: 11.3603,
    x2: 15.987,
    y2: 11.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA86F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5281,
    stopColor: "#B786F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#AE86F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA86F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_205_1983",
    x1: 17.3174,
    y1: 13.0727,
    x2: 17.3174,
    y2: 17.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#906EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575ADE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_205_1983",
    x1: 3.82656,
    y1: 13.0727,
    x2: 3.82656,
    y2: 17.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#906EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575ADE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_205_1983",
    x1: 1.86302,
    y1: 2.72998,
    x2: 9.1562,
    y2: 2.72998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB65ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E560E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_205_1983",
    x1: 11.984,
    y1: 2.72998,
    x2: 19.2772,
    y2: 2.72998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E560E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2946,
    stopColor: "#DE61E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#CC63E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB65ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_205_1983",
    x1: 7.28362,
    y1: 5.43502,
    x2: 7.28362,
    y2: 9.80699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC69E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C289F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_205_1983",
    x1: 13.8566,
    y1: 5.43502,
    x2: 13.8566,
    y2: 9.80699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC69E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C289F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_205_1983",
    x1: 15.3805,
    y1: 9.23862,
    x2: 15.3805,
    y2: 17.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6848BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#6356D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_205_1983",
    x1: 5.75984,
    y1: 13.0726,
    x2: 5.75984,
    y2: 16.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6848BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#6356D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_205_1983",
    x1: 11.8703,
    y1: 14.5805,
    x2: 11.8703,
    y2: 9.80701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA86F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5281,
    stopColor: "#B786F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#AE86F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA86F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_205_1983",
    x1: 9.01979,
    y1: 12.1938,
    x2: 9.52017,
    y2: 12.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA86F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5281,
    stopColor: "#B786F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#AE86F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA86F6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaskFox);
export default __webpack_public_path__ + "static/media/flask_fox.d1b30e6e6268d8251b31e422b3e0e59f.svg";
export { ForwardRef as ReactComponent };